import { graphicFadeOut, segmentFadeOut, tagFadeOut } from "./common";

import { array } from "@visactor/vutils";

export function commonLineFadeOut(line, label, duration, delay, easing) {
    segmentFadeOut(line, delay, duration, easing), array(label).forEach((labelNode => {
        tagFadeOut(labelNode, delay, duration, easing);
    }));
}

export function areaFadeOut(area, label, duration, delay, easing) {
    graphicFadeOut(area, delay, duration, easing), array(label).forEach((labelNode => {
        tagFadeOut(labelNode, delay, duration, easing);
    }));
}

export function arcAreaFadeOut(area, label, duration, delay, easing) {
    graphicFadeOut(area, delay, duration, easing), array(label).forEach((labelNode => {
        tagFadeOut(labelNode, delay, duration, easing);
    }));
}

export function pointFadeOut(itemLine, decorativeLine, item, duration, delay, easing) {
    var _a;
    segmentFadeOut(itemLine, delay, duration, easing), graphicFadeOut(decorativeLine, delay, duration, easing), 
    (null === (_a = item.getTextShape) || void 0 === _a ? void 0 : _a.call(item)) ? tagFadeOut(item, delay, duration, easing) : graphicFadeOut(item, delay, duration, easing);
}
//# sourceMappingURL=fade-out.js.map
